import styled from 'styled-components';

export const Wrapper = styled.div`
	opacity: 0.3;
	cursor: default;
`;
